import styled from 'styled-components';
import { inputValueTint } from './format';

// The grid cells the table draws rows out of, shared by FeedRowsTable and coreCells.
//
// Here rather than in either of them because the renderers moved out of the table and these came
// with them — but the table still places the optional and member cells itself, so both need the
// same boxes. A second copy in either file is how two cells in one row end up stretching
// differently.

// The tint props for a washed score, or nothing at all for a score of zero or none.
export const scoreTint = (score, scale) => {
  const tint = typeof score === 'number' && isFinite(score) ? inputValueTint(score, scale) : null;
  return { $tintToken: tint?.token, $tintAlpha: tint?.alpha };
};

// Stretches so a washed value cell can fill the row's height.
export const ScoreCell = styled.div`
  display: flex;
  align-self: stretch;
  min-width: 0;
`;

export const MarkerCell = styled.div`
  display: flex;
  align-self: stretch;
  min-width: 0;
`;

// Painted for the same reason the header is: it's sticky horizontally, so the middle columns scroll
// underneath it and need something opaque to scroll under. Same raised-surface token, so the frozen
// column and the header read as one piece of chrome rather than two different whites.
export const FrozenCell = styled.div`
  position: sticky;
  left: 0;
  z-index: 1;
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  /* Stretched rather than centred, so the paint covers the whole grid area and no sliver of a
     passing cell shows above or below it. Not a negative margin against the row's padding: that
     padding changes with row density. */
  display: flex;
  align-items: center;
  align-self: stretch;
`;

export const FrozenHeaderCell = styled(FrozenCell)`
  z-index: 3;
`;

export const NumericCell = styled.div`
  font-variant-numeric: tabular-nums;
`;

// The Change column is coloured TEXT, not a wash, and the distinction is the point. The wash on Score
// and Prev score means LEVEL — green is a high score. A wash here would mean DIRECTION — green is
// went up. One colour asserting two different things in adjacent columns is worse than no colour, so
// the change takes the ordinary treatment for a signed number instead, on the same two theme tokens
// the markers already use.
export const DeltaCell = styled.div`
  font-variant-numeric: tabular-nums;
`;
